import authAxios from "../../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../../config/axios";
import { setHttpParams } from "../../utility/utils";

const API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/ticket`;

export const quickTicketView = async (params = {}) => {
    params = setHttpParams(params);
    return authAxios.get(`${API_URI}/quickView?${params}`);
};
